import React from 'react';
import {Link} from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import {MultipleChoiceIcon, SingleChoiceIcon} from './QuestionTypeIcons';

const QuestionType = () => {
    return (
        <div>
            <h3 className="text-center">What type of question are you creating?</h3>
            <div className="question-type-selection">
                <Grid container justify="space-evenly" alignContent="center" alignItems="flex-start">
                    <Grid item xs={3}>
                        <Link to="/questions/new/single_choice">
                            <div className="center-all bordered">
                                <SingleChoiceIcon/>
                                <p>Single Choice</p>
                            </div>
                        </Link>
                    </Grid>
                    <Grid item xs={3}>
                        <Link to="/questions/new/multiple_choice">
                            <div className="center-all bordered">
                                <MultipleChoiceIcon/>
                                <p>Multiple Choice</p>
                            </div>
                        </Link>
                    </Grid>
                </Grid>
            </div>
        </div>
    );
};

export default QuestionType;
